<template>
  <div
    class="home-container container-with-titleBar"
  >
    <TitleBar
      :tips-text="TIPS_TEXT"
      :show-poi="false"
    />
    <div
      v-if="hasSignInfo"
      class="not-sign-tip"
    >
      <span>有门店分润信息发生调整，请确认</span>
      <van-button
        round
        type="danger"
        class="confirm-btn"
        size="mini"
        @click="toSign"
      >
        去确认
      </van-button>
    </div>
    <HomeBill
      v-if="!hideMenu"
      ref="homeBill"
      :account-role="accountRole"
      :exist-wallet="existWallet"
      :current-income-in-yuan="currentIncomeInYuan"
      :yesterday-income-in-yuan="yesterdayIncomeInYuan"
      :deposit="deposit"
      @do-deposit="isShowDeposit=true"
    />
    <WalletOnHomepage
      :account-role="accountRole"
      :exist-wallet="existWallet"
      @do-deposit="isShowDeposit=true"
    />
    <Analytics v-if="showAnalytics" />
    <BannerAd
      :slot-code="SlotCode.HOME_BANNER"
      :cid="cid"
      :mv-bid="$BID.HOME_AD_BANNER_MV"
      :mc-bid="$BID.HOME_AD_BANNER_MC"
    />
    <div class="menu-list">
      <template>
        <div
          v-if="tradeEffectPoi"
          class="menu-item menu-profit border1px-bottom"
          :data-bid="$BID.TRADE_EFFECT_MC"
          :data-cid="cid"
          @click="gotoPage('tradeEffectData')"
        >
          <span class="menu-title">生意通效果数据</span>
          <i class="right-arrow"></i>
        </div>
        <div
          v-if="!hideMenu && activity"
          class="menu-item menu-profit border1px-bottom"
          :data-bid="$BID.HOME_ACTIVITY"
          :data-cid="cid"
          @click="gotoPage('activity/index')"
        >
          <span class="menu-title">活动信息</span>
          <span class="activity-right">
            <span
              v-if="unpaidList&&!$isWXApplet"
              class="list-has-refund"
            >
              退款<span v-if="existTerminateLetter||activity">、</span>
            </span>
            <span v-if="existTerminateLetter">
              <span
                class="list-has-refund"
              >
                <van-icon
                  name="warning"
                  color="#FFD000"
                />解约退款通知<span v-if="activity">、</span>
              </span>
            </span>{{ activity }}
            <i class="right-arrow"></i>
          </span>
        </div>
        <div
          v-if="hasRepair"
          class="menu-item menu-profit border1px-bottom"
          @click="gotoPage('activitySupplement')"
        >
          <span class="menu-title">活动补款</span>
          <i class="right-arrow"></i>
        </div>
        <div
          v-if="false"
          class="menu-item menu-cooperation border1px-bottom"
          @click="gotoPage('poiEarn')"
        >
          <span class="menu-title">提权收益</span>
          <i class="right-arrow"></i>
        </div>
        <div
          v-if="!isThirdPartyUser && poiList.length"
          class="menu-item menu-device border1px-bottom"
          :data-bid="$BID.HOME_DEVICE"
          :data-cid="cid"
          @click="gotoPage('device')"
        >
          <span class="menu-title">设备管理</span>
          <i class="right-arrow"></i>
        </div>
        <div
          v-if="!isThirdPartyUser && poiList.length"
          class="menu-item menu-cooperation border1px-bottom"
          :data-bid="$BID.HOME_POI_INFO"
          :data-cid="cid"
          @click="gotoPage('cooperation')"
        >
          <span class="menu-title">门店信息</span>
          <i class="right-arrow"></i>
        </div>
        <div
          v-if="referenceList && referenceList.length"
          class="menu-item menu-invoiceNotice border1px-bottom"
          :data-bid="$BID.HOME_REFERENCE_INFO"
          :data-cid="cid"
          @click="gotoPage('referenceInfo')"
        >
          <span class="menu-title">结项报告</span>
          <i class="right-arrow"></i>
        </div>
        <div
          v-if="accountType===0 || accountType===1"
          class="menu-item menu-serviceLevel border1px-bottom"
          :data-bid="$BID.HOME_SERVICE_LEVEL_MV"
          :data-cid="cid"
          @click="gotoPage('service-level')"
        >
          <span
            class="menu-title"
            style="display: inline-flex;align-items: center;"
          >服务等级
            <van-icon
              size="15"
              color="#666"
              name="question-o"
              style="margin-left: 6px;"
              @click.stop="popServiceLevelExplain"
            />
          </span>
          <span class="activity-right">
            <span :style="poorServiceCnt>0?{'color': '#FF2727','font-weight':'600'}:{'font-weight':'600'}">
              {{ poorServiceCnt }}
            </span>
            <span style="margin-right:6px;">家门店昨日存在服务问题</span>
            <i class="right-arrow"></i>
          </span>
        </div>
        <div
          class="menu-item menu-invoiceNotice border1px-bottom"
          :data-bid="$BID.HOME_INVOICE"
          :data-cid="cid"
          @click="gotoPage('invoiceNotice')"
        >
          <span class="menu-title">开票详情</span>
          <i class="right-arrow"></i>
        </div>
      </template>
    </div>
    <div
      v-if="isHadPoi"
      class="contact-salesman"
      :data-bid="$BID.HOME_CONTRACT"
      :data-cid="cid"
      @click="onClickContactSalesman"
    >
      <span class="text">
        <img
          class="call-icon"
          src="@/assets/img/call@2x.png"
        />
        致电业务员
        <img
          class="arrow-right"
          src="@/assets/img/arrow-right@2x.png"
        />
      </span>
    </div>
    <AgreementModal />
    <Deposit
      v-model="isShowDeposit"
    />
    <ModalAd
      :slot-code="SlotCode.HOME_MODAL"
      :cid="cid"
      :mv-bid="$BID.HOME_AD_MODAL_MV"
      :mc-bid="$BID.HOME_AD_MODAL_MC"
    />
    <van-popup
      v-model="showServiceLevelExplain"
      position="bottom"
      round
    >
      <div class="popup-title">
        服务等级说明
      </div>
      <img
        src="@/assets/img/close-gray@3x.png"
        @click="showServiceLevelExplain = false"
      />
      <div class="popup-content">
        <div
          v-for="(item,index) in SERVICE_LEVEL_EXPLAIN_LIST"
          :key="index"
        >
          <div style="font-weight:bold;">
            {{ item.title }}
          </div>
          <div style="color:#666;">
            {{ item.value }}
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <div
          class="footer-btn"
          @click="showServiceLevelExplain = false"
        >
          知道了
        </div>
      </div>
    </van-popup>
    <NotSignPop
      :show-pop="showNotSignPop"
      :to-sign="toSign"
      :close="handleCloseNotSignPop"
    />
  </div>
</template>

<script>
import Dialog from 'vant/lib/dialog';
import {
  mapState, mapMutations, mapGetters, mapActions,
} from 'vuex';
import TitleBar from '@/components/TitleBar';
import HomeBill from '@/views/home/HomeBill';
import NotSignPop from '@/views/home/NotSignPop';
import Deposit from '@/views/home/Deposit';
import WalletOnHomepage from '@/views/wallet/WalletOnHomepage';
import Analytics from '@/views/analytics/Analytics';
import AgreementModal from '@/views/agreement/AgreementModal';
import Profit from '@/api/profit';
import BillApi from '@/api/bill';
import STATUS from '@/constants/status';
import ActivityApi from '@/api/activity';
import MerchantApi from '@/api/merchant';
import MarketingApi from '@/api/marketing';
import ServiceLevelApi from '@/api/serviceLevel';
import { ActivityTypeEnum } from '@/constants/activity';
import { ACCOUNT_ROLE } from '@/constants/common';
import { SERVICE_LEVEL_EXPLAIN_LIST } from '@/constants/serviceLevel';
import tracker from '@/util/tracker';
import { BID } from '@/constants/statistics';
import '@/assets/css/page/home.scss';
import { SlotCode } from '@/constants/ad';
import BannerAd from './ad/BannerAd';
import ModalAd from './ad/ModalAd';

const EMPTY = 0;
const CONFIRM_TIPS_TEXT = '【新】每月收益可在次月15号（含）之后发起提现。';
const NO_POI_TIPS_TEXT = '此账号未绑定门店！';
const TICKET_TIPS_TEXT = '如需开票，请严格按照【开票详情】进行发票开具！';

export default {
  name: 'Home',
  components: {
    TitleBar,
    HomeBill,
    NotSignPop,
    WalletOnHomepage,
    AgreementModal,
    Deposit,
    Analytics,
    BannerAd,
    ModalAd,
  },
  data() {
    return {
      currentIncomeInYuan: EMPTY,
      yesterdayIncomeInYuan: EMPTY,
      hasRepair: 0,
      showAddAgreement: false,
      hasConditionalPay: false,
      activity: '',
      unpaidList: false, // 存在退款信息
      accountRole: ACCOUNT_ROLE.Primary,
      existWallet: 0, //  0-不存在钱包 1-存在钱包
      hideMenu: true, // 是否隐藏 我的账单、我的收益、活动信息
      existTerminateLetter: false, // 存在活动解约通知
      deposit: 0, // 可提现金额
      isShowDeposit: false, // 是否显示提现loading组件
      showAnalytics: false, // 是否显示流量分析模块
      referenceList: [], // 结项报告列表
      tradeEffectPoi: null, // 生意通效果数据门店（门店列表中第一个门店）
      SlotCode,
      poorServiceCnt: 0,
      SERVICE_LEVEL_EXPLAIN_LIST,
      showServiceLevelExplain: false,
      showNotSignPop: false,
      appVersion: '1',
    };
  },
  computed: {
    ...mapState(['currentPoi', 'bizlogintoken', 'isAgent', 'poiList', 'accountType']),
    ...mapState('billModule', ['customerId', 'settleUnitIdList']),
    ...mapGetters(['isThirdPartyUser', 'hasSignInfo']),
    TIPS_TEXT() {
      if (this.poiList.length) {
        return `${CONFIRM_TIPS_TEXT};${TICKET_TIPS_TEXT}`;
      } else {
        return `${TICKET_TIPS_TEXT};${NO_POI_TIPS_TEXT}`;
      }
    },
    isHadPoi() {
      return this.poiList.length > 0;
    },
    cid() {
      return this.$CID.Home;
    },
  },
  async created() {
    this.$store.commit('setLoading', true);
    if (this.hasSignInfo && !sessionStorage.getItem('NotSignPopClosed')) {
      this.showNotSignPop = true;
    }
    await Promise.all([
      this.getData(),
      this.getXyRepair(),
      this.getActivity(),
      this.getHideInfo(),
      this.getAnalyticsAuth(),
      this.getReferenceList(),
      this.getTradeDataPoiList(),
      this.getPoorServiceCnt(),
      this.getSlotList([SlotCode.HOME_BANNER, SlotCode.HOME_MODAL]),
    ]);
    this.$store.commit('setLoading', false);
    document.addEventListener('visibilitychange', this.onDocumentVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onDocumentVisibilityChange);
  },
  methods: {
    ...mapMutations(['setCurrentPoi', 'setAllPois', 'setRepairInfoList']),
    ...mapMutations('billModule', ['setCustomerId', 'setSettleUnitIdList']),
    ...mapActions('adModule', ['getSlotList']),

    async getXyRepair() {
      try {
        const { respCode, data } = await Profit.getXyRepair();
        if (respCode === STATUS.SUCCESS && data) {
          this.hasRepair = data.hasRepair;
          this.setRepairInfoList(data.repairInfoList);
        }
      } catch (e) {
        console.error(e);
      }
    },

    // eslint-disable-next-line complexity
    async getActivity() {
      try {
        const { code, data = '' } = await ActivityApi.getActivity();

        if (code === STATUS.SUCCESS) {
          const agreementTypes = data.agreementTypes || '';
          const arr = [];
          // 判断是否包含预付款
          if (agreementTypes.indexOf(`${ActivityTypeEnum.PRE_PAY}`) !== -1 || agreementTypes.indexOf(`${ActivityTypeEnum.CIRCLE_PRE_PAY}`) !== -1) {
            arr.push('预付款');
          }
          // 判断是否包含条件付
          if (agreementTypes.indexOf(`${ActivityTypeEnum.CONDITION_PAY}`) !== -1) {
            arr.push('条件付');
          }
          // 判断是否包含进场费
          if (agreementTypes.indexOf(`${ActivityTypeEnum.SLOTTING_FEE}`) !== -1) {
            arr.push('进场费');
          }
          // 判断是否包含合作商循环预付费
          if (agreementTypes.indexOf(`${ActivityTypeEnum.AGENT_PRE_PAY}`) !== -1) {
            arr.push('循环预付款');
          }
          // 判断是否包含合作商进场费
          if (agreementTypes.indexOf(`${ActivityTypeEnum.AGENT_SLOTTING_FEE}`) !== -1) {
            arr.push('进场费');
          }
          // 判断是否包含合作商条件付
          if (agreementTypes.indexOf(`${ActivityTypeEnum.AGENT_CONDITION_PAY}`) !== -1) {
            arr.push('条件付');
          }
          this.activity = arr.join('、');
          this.existTerminateLetter = data.existTerminateLetter;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getHideInfo() {
      try {
        const { code, data } = await MerchantApi.getHideInfo();

        if (code === STATUS.SUCCESS) {
          this.hideMenu = data;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getUnPaidList(customerId) {
      const { code, data = {} } = await ActivityApi.getUnPaidList(customerId);
      if (code === STATUS.SUCCESS) {
        if (data.agreementList && data.agreementList.length) {
          this.unpaidList = true;
        }
      }
    },

    async getDepositAmount() {
      const { customerId, accountType, settleUnitIdList } = this;
      const { code, data } = await BillApi.getDepositAmount({ customerId, accountType, settleUnitIdList });
      if (code === STATUS.SUCCESS) {
        this.deposit = Number(data.canWithdrawAmount) || 0;
        if (this.$refs.homeBill) {
          this.$refs.homeBill.trackMV();
        }
      } else {
        Dialog.alert({ message: '获取可提现金额失败，请重试。' }).then(() => this.getDepositAmount()).catch(() => {});
      }
    },

    async getPoorServiceCnt() {
      if (this.accountType === 0 || this.accountType === 1) {
        tracker.sendModuleView(this.$BID.HOME_SERVIVE_LEVEL_MV, null, { cid: this.cid });
        const partnerId = this.$store.getters['partnerModule/id'];
        const params = { partnerId };
        const { error, data } = await ServiceLevelApi.getPoiCnt(params);
        if (data && !error) {
          this.poorServiceCnt = data.poorServiceCnt;
        }
      }
    },

    popServiceLevelExplain() {
      this.showServiceLevelExplain = true;
      tracker.sendModuleClick(BID.HOME_SERVIVE_LEVEL_EXPLAIN_MC, null, { cid: this.cid });
    },

    async getData() {
      const { poiId } = this.currentPoi;
      this.poiId = poiId;
      this.setAllPois(!poiId);
      try {
        const res = await BillApi.getHomeIncome();
        if (res.code === STATUS.SUCCESS) {
          const {
            curMonthIncome, yesterdayIncome, customerId, settleUnitIdList, accountRole, exsitWallet: existWallet,
          } = res.data || {};
          this.currentIncomeInYuan = curMonthIncome || EMPTY;
          this.yesterdayIncomeInYuan = yesterdayIncome || EMPTY;
          this.setCustomerId(customerId);
          this.setSettleUnitIdList(settleUnitIdList);
          this.getUnPaidList(customerId);
          this.accountRole = accountRole;
          this.existWallet = existWallet;
          this.getDepositAmount();
        }
      } catch (e) {
        console.error(e);
      }
    },

    async getReferenceList() {
      const { data } = await MarketingApi.getReferenceList(this.customerId);
      this.referenceList = data && data.list;
    },

    async getTradeDataPoiList() {
      const { data } = await MarketingApi.getTradeDataPoiList();
      if (data && data.list && data.list.length) {
        this.tradeEffectPoi = data.list[0];
        if (this.tradeEffectPoi) {
          tracker.sendModuleView(this.$BID.HOME_WALLET_MV, null, { cid: this.cid });
        }
      }
    },

    // eslint-disable-next-line complexity
    gotoPage(page) {
      if (page === 'profit' && this.isThirdPartyUser) {
        return;
      }
      switch (page) {
      case 'cooperation':
        if (!this.poiId) {
          this.setAllPois(false);
          this.setCurrentPoi(this.poiList[1] || this.poiList[0]);
        }
        this.$router.push(`/cooperation?bizlogintoken=${this.bizlogintoken}`);
        break;
      case 'device':
        if (!this.poiId) {
          this.setAllPois(false);
          this.setCurrentPoi(this.poiList[1] || this.poiList[0]);
        }
        this.$router.push('/device');
        break;
      case 'poiEarn':
        if (!this.poiId) {
          this.setAllPois(false);
          this.setCurrentPoi(this.poiList[1] || this.poiList[0]);
        }
        this.$router.push({
          name: 'PoiEarn',
          query: {
            switchPoi: true,
          },
        });
        break;
      case 'referenceInfo':
        this.$router.push('/referenceinfo/list');
        break;
      case 'tradeEffectData':
        this.$router.push({ name: 'TradeEffectData', query: this.tradeEffectPoi });
        break;
      case 'service-level':
        tracker.sendModuleClick(this.$BID.HOME_SERVIVE_LEVEL_MC, null, { cid: this.cid });
        this.$router.push('/service-level/poi-list');
        break;
      default:
        this.$router.push(`/${page}`);
      }
    },

    async getAnalyticsAuth() {
      const data = await MarketingApi.getAuth();
      if (data && data.data === 1) {
        this.showAnalytics = true;
      }
    },

    onClickContactSalesman() {
      tracker.sendModuleClick(BID.HOME_PROFIT_TIP, null, { cid: this.cid });
      this.gotoPage('askForHelp');
    },

    onDocumentVisibilityChange() {
      if (!document.hidden) {
        this.getDepositAmount();
      }
    },

    handleCloseNotSignPop() {
      this.showNotSignPop = false;
      sessionStorage.setItem('NotSignPopClosed', 'true');
      // 可以在这里添加其他关闭后的逻辑
      console.log('未签约弹窗已关闭');
    },
    toSign() {
      this.$router.push('/notSign');
    },
  },
};
</script>
<style lang="scss" scoped>
.container-with-titleBar{
  padding-bottom: 136px;
}
.list-has-refund {
  color: #ff4a00;
}
.not-sign-tip{
  background: #FFF1F0;
  margin: 0 18px -30px;
  height: 118px;
  padding: 24px;
  border-radius: 24px;
  font-weight: 400;
  color: #FF2D19;
  font-family: PingFang SC;
  font-size: 28px;
  line-height: 40px;
  text-align: left;
  display: flex;
  justify-content: space-between;
}
.activity-right {
  display:inline-block;
  max-width:400px;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.contact-salesman {
  position: fixed;
  width: 100%;
  background: #fff;
  padding: 16px 0;
  bottom: 0;
  margin-top: 48px;
  display: flex;
  justify-content: center;

  .text {
    width: 380px;
    height: 88px;
    border: 2px solid #666;
    border-radius: 44px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .call-icon {
      width: 30px;
      height: 30px;
      margin-right: 12px;
    }

    .arrow-right {
      width: 24px;
      height: 24px;
      margin-left: 6px;
    }
  }
}
.van-popup {
  text-align: left;
  .popup-title {
    font-size: 4.267vw;
    font-weight: bold;
    line-height: 4.267vw;
    text-align: center;
    margin-top: 5.333vw;
  }
  img {
    width:5.867vw;
    position: absolute;
    top: 4.533vw;
    right: 4vw
  }
  .popup-content {
    font-size: 3.733vw;
    display: flex;
    flex-direction: column; /* 设置为纵向排列 */
    justify-content: space-between;
    gap: 4vw;
    padding: 4.8vw 4vw 4vw 4vw;
    max-height: 70vh;
    overflow-y: auto;
  }
  .popup-footer {
    width: 100%;
    height: 22.933vw;
    display: flex;
    justify-content: center;
    border-top: 1px solid #E5E5E5;
    .footer-btn {
      width: 93.6vw;
      height: 11.733vw;
      border-radius: 7.467vw;
      font-size: 4.267vw;
      margin-top: 2.4vw;
      font-weight: bold;
      background: #FFCC33;
      display: flex;
      justify-content: center;
      align-items: center
    }
  }
}
.van-popup--round {
  border-radius: 3.2vw 3.2vw 0 0;
}
</style>
